import { TRANSFER_STOP } from '@/lib/constants';
import { SegmentLinkModel, SegmentTransferModel } from '@/lib/models/segment/types';
import { RouteLinkSegmentEventApiV4Interface } from '@/types/api-types';

export const getSegmentStopEvents = ({
  segments,
}: {
  segments: (SegmentTransferModel | SegmentLinkModel)[];
}): RouteLinkSegmentEventApiV4Interface[] => {
  return segments.reduce((acc, segment) => {
    if ('events' in segment && segment.events.length) {
      return segment.events[0]
        .map((event) => {
          if (event.type === TRANSFER_STOP) {
            return event;
          }
          return null;
        })
        .filter((event): event is RouteLinkSegmentEventApiV4Interface => Boolean(event));
    }
    return acc;
  }, [] as RouteLinkSegmentEventApiV4Interface[]);
};
